// extracted by mini-css-extract-plugin
export default {"Cocos3dGame":"cocos3d_Cocos3dGame_lXJLi","load_title_img":"cocos3d_load_title_img_Sqnza"};